import {
  Building2, Droplets, Flower, Flower2, Home, Leaf, PencilRuler,
  Scissors, Shrub, Sprout, Tractor, TreePine, Trees,
} from "lucide-react";
import { SERVICES } from "@/data/services";

const ICONS = {
  "lawn-care": Leaf,
  "lawn-mowing": Scissors,
  "lawn-treatment": Sprout,
  "sprinklers": Droplets,
  "flower-bed-installation": Flower2,
  "flower-planting": Flower,
  "tree-trimming": TreePine,
  "tree-care": Trees,
  "bush-shrub": Shrub,
  "landscape-design": PencilRuler,
  "general-landscaping": Tractor,
  "residential": Home,
  "commercial": Building2,
};

export default function Services({ onRequestEstimate, overrides = {} }) {
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 bg-surface scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <span className="text-brand font-bold uppercase tracking-widest text-sm">Our Services</span>
          <h2 className="mt-3 font-heading font-bold text-ink text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug">
            Landscaping Services for Every Property
          </h2>
          <div className="mt-5 h-1.5 w-24 bg-brand rounded-full" aria-hidden="true" />
          <p className="mt-4 text-[#4B5563] text-lg leading-relaxed">
            Every job is quoted individually after a free on-site estimate — no guesswork, no surprises.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {SERVICES.map((service) => {
            const Icon = ICONS[service.id] || Leaf;
            return (
              <article
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="bg-white border border-border p-6 rounded-xl flex flex-col items-start gap-4 hover:shadow-md transition-shadow duration-200"
              >
                <span className="w-12 h-12 rounded-full bg-brand-light flex items-center justify-center">
                  <Icon className="w-6 h-6 text-brand" aria-hidden="true" />
                </span>
                <h3 className="font-heading font-semibold text-ink text-lg leading-snug">{service.name}</h3>
                <p className="text-sm text-[#4B5563] leading-relaxed flex-1">
                  {overrides[service.id] || service.description}
                </p>
                <button
                  type="button"
                  data-testid={`service-estimate-button-${service.id}`}
                  onClick={() => onRequestEstimate(service.name)}
                  className="text-brand font-semibold text-sm hover:text-brand-hover transition-colors inline-flex items-center gap-1.5"
                >
                  Request Estimate
                  <span aria-hidden="true">→</span>
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
